<template>
  <v-container>
    <h1>Languages</h1>
    <LanguagesTable  v-on:edit="edit($event)"></LanguagesTable>
    <LanguagesDialog v-model="dialog" :model="model"></LanguagesDialog>
    <v-btn
            fixed
            dark
            fab
            right
            bottom
            color="pink"
            v-on:click="create"
    >
      <v-icon>add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import LanguagesTable from '../components/LanguagesTable'
import LanguagesDialog from '../components/LanguagesDialog'

export default {
  components: { LanguagesTable, LanguagesDialog },
  data () {
    return {
      model: null,
      dialog: false
    }
  },
  methods: {
    create () {
      this.model = null
      this.dialog = true
    },
    edit (model) {
      this.model = model
      this.dialog = true
    }
  }
}
</script>
